export default __webpack_public_path__ + "static/media/dvantage-icon.27b80a0f.svg";